import { Injectable } from '@angular/core';
import { RegisterData } from '../components/pages/register-page/interfaces/register-data.interface';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageDataService {
  constructor() { }

    // Guardar datos en sessionStorageDataService
    saveData(key: string, valFormRegis: any | RegisterData) {
      sessionStorage.setItem(key, JSON.stringify(valFormRegis));
      if (key === 'data_register') {
        this.startTimer(key);
      }

    }

    // Recuperar datos de sessionStorageDataService
    getData(key: string): any | null {
      const value = sessionStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    }

    // Eliminar datos de sessionStorageDataService
    removeData(key: string) {
      sessionStorage.removeItem(key);
    }

    // Limpiar todos los datos
    clearData() {
      sessionStorage.clear();
    }

    startTimer(key: string) {
      const fifteenMinutes = 15 * 60 * 1000;

      setTimeout(() => {
        this.removeData(key);
      }, fifteenMinutes);
    }
}